import { render } from "./diretor-all.vue?vue&type=template&id=7931f546&scoped=true"
import script from "./diretor-all.vue?vue&type=script&lang=js"
export * from "./diretor-all.vue?vue&type=script&lang=js"

import "./diretor-all.vue?vue&type=style&index=0&id=7931f546&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7931f546"]])

export default __exports__